"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Sarah T.",
  quote: "The peace of mind knowing Mom is safe and loved at Moonrise is priceless. The staff truly treats her like family, providing care that is both professional and deeply compassionate.",
  position: "Daughter of Resident",
  initials: "ST"
}, {
  author: "James M.",
  quote: "Moonrise provides a warm, home-like environment that made the transition so much easier for my father. Their attention to detail and personalized care plans are exceptional.",
  position: "Family Member",
  initials: "JM"
}];
export default function WordsOfComfort() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="102869" id="voices-of-our-families" className="relative py-24 md:py-32 bg-[#f0f4f8] overflow-hidden flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,transparent_0%,rgba(9,27,58,0.03)_100%)]" />

      <div ref={ref} className={`container mx-auto px-6 md:px-12 max-w-5xl relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col items-center text-center mb-12">
          <Quote className="size-16 text-[#091b3a]/10 mb-6" strokeWidth={1.5} />
          <h2 className="sr-only">Voices of Our Families</h2>
        </div>

        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center px-4 md:px-16">
                  <p className="font-sans font-medium text-[28px] md:text-4xl leading-relaxed md:leading-snug text-[#091b3a] text-center mb-10 max-w-3xl mx-auto text-balance">
                    "{testimonial.quote}"
                  </p>
                  
                  <div className="flex flex-col items-center gap-3">
                    <SafeHydrate><Avatar className="size-14 border border-[#091b3a]/10 shadow-md">
                      <AvatarImage src={`/img/avatar_${testimonial.initials.toLowerCase()}.png`} alt={testimonial.author} />
                      <AvatarFallback className="bg-[#091b3a] text-white font-sans text-lg">
                        {testimonial.initials}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="text-center">
                      <div className="font-semibold text-[hsl(44_100%_50%)] tracking-wide text-lg">
                        {testimonial.author}
                      </div>
                      <div className="text-sm text-[#091b3a]/70 mt-0.5 font-medium">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="left-0 lg:-left-12 border-none bg-[#091b3a] hover:bg-[#091b3a]/90 text-white size-12 [&_svg]:size-6 transition-all shadow-lg" />
            <CarouselNext className="right-0 lg:-right-12 border-none bg-[#091b3a] hover:bg-[#091b3a]/90 text-white size-12 [&_svg]:size-6 transition-all shadow-lg" />
          </div>
        </Carousel>
      </div>
    </section>;
}